import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { getErrorMessage } from '@/shared/lib/errors';
import { chatReplyTemplateService } from '../api/chatReplyTemplateService';
import type { ChatReplyState } from './types';

/** Хранит папки и шаблоны сообщений чата */
export const useChatReplyTemplates = create<ChatReplyState>((set, get) => ({
    catalog: null,
    status: RequestStatus.Idle,
    error: null,
    revision: 0,

    load: async (force = false) => {
        const reuse = !force && (get().status === RequestStatus.Loading || get().status === RequestStatus.Success);

        if (reuse) return;

        const revision = get().revision + 1;

        set({
            revision,
            status: RequestStatus.Loading,
            error: null
        });

        try {
            const catalog = await chatReplyTemplateService.getCatalog();

            if (get().revision !== revision) return;

            set({
                catalog,
                status: RequestStatus.Success
            });
        } catch (error: unknown) {
            if (get().revision !== revision) return;

            set({
                status: RequestStatus.Error,
                error: getErrorMessage(error, 'Не удалось загрузить шаблоны')
            });
        }
    },

    reset: () => set({
        catalog: null,
        status: RequestStatus.Idle,
        error: null,
        revision: get().revision + 1
    }),
}));
